export default __webpack_public_path__ + "static/WDRMODE_0-e11965ac6d6b4d3b9ce53a9fb64519f6.avif";